import createIcon from '../../createIcon';

/**
 * @component @name AddChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41IDkuOTlINy41VjE2Ljk5SDUuNVY5Ljk5Wk0xMy41IDEyLjk5SDE1LjVWMTYuOTlIMTMuNVYxMi45OVpNOS41IDYuOTlIMTEuNVYxNi45OUg5LjVWNi45OVpNMTkuNSA3VjRIMTcuNVY3SDE0LjVWOUgxNy41VjEySDE5LjVWOUgyMi41VjdIMTkuNVpNMTcuNSAxOUgzLjVWNUgxNS41VjNIMy41QzIuNCAzIDEuNSAzLjkgMS41IDVWMTlDMS41IDIwLjEgMi40IDIxIDMuNSAyMUgxNy41QzE4LjYgMjEgMTkuNSAyMC4xIDE5LjUgMTlWMTRIMTcuNVYxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddChart = createIcon('AddChart', [
  [
    'path',
    {
      d: 'M5.5 9.99H7.5V16.99H5.5V9.99ZM13.5 12.99H15.5V16.99H13.5V12.99ZM9.5 6.99H11.5V16.99H9.5V6.99ZM19.5 7V4H17.5V7H14.5V9H17.5V12H19.5V9H22.5V7H19.5ZM17.5 19H3.5V5H15.5V3H3.5C2.4 3 1.5 3.9 1.5 5V19C1.5 20.1 2.4 21 3.5 21H17.5C18.6 21 19.5 20.1 19.5 19V14H17.5V19Z',
      key: 'nr6qui',
    },
  ],
]);

export default AddChart;
